import ru from './auth.ru.json'
import en from './auth.en.json'
import i18n from '@/translations/i18n'

i18n.append([{ ru, en, prefix: 'auth.' }])
